import { render, staticRenderFns } from "./cardVoiceMgt.vue?vue&type=template&id=8df5b462&scoped=true&"
import script from "./cardVoiceMgt.vue?vue&type=script&lang=js&"
export * from "./cardVoiceMgt.vue?vue&type=script&lang=js&"
import style0 from "./cardVoiceMgt.vue?vue&type=style&index=0&id=8df5b462&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8df5b462",
  null
  
)

export default component.exports